export const SERVER_URL = "https://onegoldapi.pukat.net";